import BaseChart from "../../../../../components/BaseChart";
import auth from "../../../../../utils/auth";
import permission from "../../../../../utils/permissions";
import styles from "../../Dashboard.module.css";

const Charts = ({ marker, openFullCharts }) => {

    const buildPreset = (chart) => {
        const baseSeries = chart.series.map(serie => ({
            ...serie,
            type: serie.tipo,
            ...(serie.tipo === "line"
                ? {
                    smooth: true,
                    symbol: "circle",
                    symbolSize: 4,
                    lineStyle: { width: 2 },
                    areaStyle: { opacity: 0.05 }
                }
                : {
                    barWidth: 6,
                    itemStyle: { borderRadius: [3, 3, 0, 0] }
                }
            ),
        }));

        return {
            grid: { top: 10, left: 10, right: 10, bottom: 20 },
            legend: { show: false },
            tooltip: { show: false },
            yAxis: {
                show: false,
            },
            dataZoom: [],
            series: [...baseSeries]
        };
    };

    const charts = marker?.graficos || [];
    const isMasterOrAdmin = auth.isMasterOrAdmin();
    const canAccess = isMasterOrAdmin || permission.canAccess("/graficos/");

    return (
        <div className={styles.chartsWrapper}>
            <div className={styles.chartsScrollArea}>
                {charts.length ? (
                    charts.map(chart => (
                        <div key={chart.id} className={styles.chartBlock}>
                            <div className={styles.chartTitle}>
                                {chart.descricao}
                            </div>

                            {chart.series.some(serie => serie.data.length) ? (
                                <BaseChart
                                    id={chart.id}
                                    tipo={chart.tipo}
                                    series={chart.series}
                                    compactMode
                                    chartStyle={{ height: "110px" }}
                                    customOptions={buildPreset(chart)}
                                />
                            ) : (
                                <div className={styles.chartBlockEmpty}>
                                    Nenhum dado disponível!
                                </div>
                            )}
                        </div>
                    ))
                ) : (
                    <div className={styles.chartBlockEmpty}>
                        Nenhum gráfico disponível!
                    </div>
                )}
            </div>

            {(charts.length > 0 && canAccess) && (
                <div className={styles.chartFooter}>
                    <button
                        className={styles.fullChartButton}
                        onClick={openFullCharts}
                    >
                        <i className="fa fa-chart-line" />
                        Ver gráfico completo
                    </button>
                </div>
            )}
        </div>
    );
}

export default Charts;